import React, { useEffect } from "react";

import { gsap } from "gsap";

const IM = () => {
  const styles = {
    blackbg: {
      backgroundColor: "#121212",
    },
    blueText: {
      color: "#037ef3",
    },
    gradient: {
      background: "linear-gradient(90deg, rgba(251,74,0,1) 35%, rgba(21,2,236,1) 100%)",
    },
    hidden: {
      visibility: "hidden",
    },
  };

  useEffect(() => {
    gsap.fromTo(
      ".section",
      {
        autoAlpha: 0,
        y: 100,
      },
      {
        autoAlpha: 1,
        y: 0,
        ease: "expo.inOut",
        duration: 1,
        stagger: 0.1,
      }
    );
  });

  return (
    <div className="w-full h-full text-white " style={styles.blackbg}>
      <div className="w-full max-w-2xl m-auto py-8 px-4">
        <div className="text-xl section" style={styles.blueText}>
          AIESEC in SLIIT
        </div>
        <div className="text-4xl font-bold section">
          <div className="p-4 rounded-lg" style={styles.gradient}>
            Information Management Team
          </div>
          <div className="text-2xl"></div>
        </div>

        <div className="text-xl mt-1 text-gray-400 section">Application Package</div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Introduction</div>
          <p className="text-gray-400">
            <span className="rounded-md" style={styles.gradient}>
              &nbsp;Information Management&nbsp;
            </span>{" "}
            is the function that focuses on improving the digital infrastructre of the entity and making the entity's internal processes easier, 
faster as well as more efficent using the technical resources.
          </p>
        </div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Timeline</div>
          <div>
            <span className="font-bold">Application Open - </span> <span className="text-gray-300">23rd of May 2022</span> <br />
            <span className="font-bold">Application Deadline - </span> <span className="text-gray-300">27th of May 2022</span> <br />
          </div>
        </div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Team Structure</div>
          <div>
            <span className="">Tech Lead</span> <br />
            <span className="">Developer</span> <br />
            <span className="">Data Analyst</span> <br />
          </div>
        </div>

        <div className="mt-8 section">
          <div className="w-full h-1 bg-gray-700 mb-8"></div>
          <div className="text-2xl mb-1 font-semibold">Available Roles</div>
          <br />
          {/*  =====================================================  */}
          <div className="w-full rounded-lg border p-2" style={{ border: "2px solid #FFC845" }}>
            <div className="text-center text-2xl font-bold" style={{ color: "#FFC845" }}>
              Developer <span className="text-gray-500"> x2</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Development (front end & Backend) and maintenance of tools to suit the requirements of AIESEC in SLIIT.</li>
                <li>Identify the touchpoints to automate the current processes inside the entity.</li>
                <li>Organizing education projects/sessions for software IM downscaling to the membership.</li>
              </ul>
            </div>
            <br />
            <div className="font-bold">KPIs/MoS</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li># tools developed.</li>
                <li> # process that automated.</li>
                <li># session and projects initiated.</li>
              </ul>
            </div>
          
          <br />
          <br />
            <div className="font-bold">Requirements</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Technical Skills (MERN Stack preferred).</li>
                <li> Information Technology/Software Engineering Background preferred.</li>
              </ul>
            </div>
          </div>{" "}
          </div>
          <br />
          {/*  =====================================================  */}
          {/*  =====================================================  */}
          <div className="w-full rounded-lg border p-2" style={{ border: "2px solid #FFC845" }}>
            <div className="text-center text-2xl font-bold" style={{ color: "#FFC845" }}>
              Data Analyst <span className="text-gray-500"> x1</span>
            </div>
            <div className="font-bold">Job Description</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Development of dashboard tools to suit the requirements of AIESEC in SLIIT.</li>
                <li>Identify the touchpoints related to Data Science/Analytics and provide data solutions to increase the growth of the organization and process optimization.</li>
                <li>Organizing education projects/sessions for software IM downscaling to the membership.</li>
              </ul>
            </div>
            <br />
            <div className="font-bold">KPIs/MoS</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li># tools developed.</li>
                <li> # data solutions provided.</li>
                <li># session and projects initiated.</li>
              </ul>
            </div>
          
          <br />
          <br />
            <div className="font-bold">Requirements</div>
            <div className="text-gray-400">
              <ul className="list-inside list-disc">
                <li>Technical Skills (Data Studio & Biquery preferred).</li>
                <li>Advanced/Intermediate Spreadsheet skills (Google Sheet Required)</li>
                <li> Information Technology/Data Science/Software Engineering Background preferred.</li>
              </ul>
            </div>
          </div>{" "}
          <br />
          

           {/** Contact Info ***/}
           <div className="mt-8">
            <div className="w-full h-1 bg-gray-700 mb-8"></div>
            <div className="text-2xl mb-4 font-semibold">Contact Info</div>
            <div>
              <div>For any clarifications, </div>
              <div style={styles.blueText} className="text-3xl">
                Fouzul Hassan
              </div>
              <div className="text-gray-400">OEVP FnL & IM – AIESEC in SLIIT</div>
              <div className="text-gray-400">fouzul.hassan@aiesec.net</div>
              <div className="text-gray-400">+94 70 309 0599</div>
            </div>
          </div>
          <a href="https://forms.gle/dCiXHsUiyQvq7UtY8" target="_blank" rel="noreferrer">
            <div className="my-8 rounded-md w-full h-10 text-center text-lg font-bold grid content-center cursor-pointer" style={{ background: "#037ef3" }}>
              Apply
            </div>
          </a>
        </div>
        </div>

  );
};

export default IM;
